// src/components/CookieConsent.jsx
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { loadTrackingScripts } from '../utils/analytics';

export const CONSENT_KEY = 'cookie-consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (consent === 'accepted') {
      loadTrackingScripts();
    } else if (consent !== 'rejected') {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    loadTrackingScripts();
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(CONSENT_KEY, 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[100] bg-darkblue1 text-white px-6 py-5 shadow-2xl font-cormorant">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center gap-4 sm:justify-between">
        <p className="text-sm sm:text-base text-white/90 leading-relaxed text-center sm:text-left">
          Usamos cookies de análise (Google Analytics, Google Tag Manager e Facebook) para entender
          como você usa o site. Ao clicar em "Aceitar", você concorda com o uso desses cookies,
          conforme nossa{' '}
          <Link to="/politica-de-privacidade" className="underline hover:text-darkredHighlight">
            Política de Privacidade
          </Link>.
        </p>
        <div className="flex gap-3 flex-shrink-0">
          <button
            onClick={handleReject}
            className="px-5 py-2 rounded-full border border-white/40 text-white text-sm hover:bg-white/10 transition"
          >
            Recusar
          </button>
          <button
            onClick={handleAccept}
            className="px-5 py-2 rounded-full bg-darkred1 hover:bg-darkred2 text-white text-sm font-semibold transition"
          >
            Aceitar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
